import script from "./MailSecurityCompleteView.vue?vue&type=script&lang=ts&setup=true"
export * from "./MailSecurityCompleteView.vue?vue&type=script&lang=ts&setup=true"

import "./MailSecurityCompleteView.vue?vue&type=style&index=0&id=4be23cd4&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4be23cd4"]])

export default __exports__